import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const userApi = createApi({
  reducerPath: 'user-api',
  baseQuery: createBaseQuery(),
  endpoints: () => ({}),
});
